<template>
    <div class="container fluid">
        <content-navigation :titles="topNav"/>
        <h3 class="contacts-title">КОРЗИНА</h3>
        <hr>
        <template v-if="itemInCart">
            <template v-if="loading">
                <preloader></preloader>
            </template>
            <template v-else>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 img-outer">
                        <div class="img-wrapper">
                            <img :src="getAvatar(itemInCart.avatar)" alt="logo" class="image">
                        </div>
                    </div>

                    <div class="col-12 col-md-6 tech-settings">
                        <p class="item-id mb-3">{{itemInCart.code}}</p>
                        <p class="item-title mb-3">{{itemInCart.title}}</p>
                        <p class="item mt-2 mb-2">Teхнические характеристики:</p>
                        <div class="settings mb-0" >
                            <template v-if="itemInCart.footage_total">
                                <div class="setting-item">
                                    <span class="setting-name">Общая площадь внутренних помещений:</span>
                                    <span class="setting-value">{{itemInCart.footage_total}} м<sup>2</sup></span>
                                </div>
                            </template>
                            <template v-if="itemInCart.footage_porch">
                                <div class="setting-item">
                                    <span class="setting-name">Площадь крылец, террас, балконов:</span>
                                    <span class="setting-value">{{itemInCart.footage_porch}} м<sup>2</sup></span>
                                </div>
                            </template>
                            <template v-if="itemInCart.footage_living">
                                <div class="setting-item">
                                    <span class="setting-name">Жилая площадь:</span>
                                    <span class="setting-value">{{itemInCart.footage_living}} м<sup>2</sup></span>
                                </div>
                            </template>
                            <template v-for="option in itemInCart.options">
                                <div class="setting-item" :key="option.id" v-if="option.filter_id">
                                    <span class="setting-name">{{getFilterName(option.filter_id)}}:</span>
                                    <span class="setting-value">{{getOptionName(option)}}</span>
                                </div>
                            </template>
                            <template>
                                <div class="setting-item">
                                    <span class="setting-name">Наличие мансардного этажа:</span>
                                    <span class="setting-value">{{itemInCart.attic ? 'Да' : 'Нет'}} </span>
                                </div>
                            </template>
                            <template>
                                <div class="setting-item">
                                    <span class="setting-name">Наличие цокольного этажа:</span>
                                    <span class="setting-value">{{itemInCart.cap ? 'Да' : 'Нет'}} </span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_basement">
                                <div class="setting-item">
                                    <span class="setting-name">Высота подвала:</span>
                                    <span class="setting-value">{{itemInCart.height_basement}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_cap">
                                <div class="setting-item">
                                    <span class="setting-name">Высота подвала:</span>
                                    <span class="setting-value">{{itemInCart.height_cap}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_1">
                                <div class="setting-item">
                                    <span class="setting-name">Высота 1 этажа:</span>
                                    <span class="setting-value">{{itemInCart.height_1}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_2">
                                <div class="setting-item">
                                    <span class="setting-name">Высота 2 этажа:</span>
                                    <span class="setting-value">{{itemInCart.height_2}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_3">
                                <div class="setting-item">
                                    <span class="setting-name">Высота 3 этажа:</span>
                                    <span class="setting-value">{{itemInCart.height_3}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_attic_floor">
                                <div class="setting-item">
                                    <span class="setting-name">Высота мансардного этажа:</span>
                                    <span class="setting-value">{{itemInCart.height_attic_floor}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_attic_vertical_wall">
                                <div class="setting-item">
                                    <span class="setting-name">Высота вертикальной стены мансардного этажа:</span>
                                    <span class="setting-value">{{itemInCart.height_attic_vertical_wall}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_attic_full">
                                <div class="setting-item">
                                    <span class="setting-name">Общая высота мансардного этажа:</span>
                                    <span class="setting-value">{{itemInCart.height_attic_full}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_attic">
                                <div class="setting-item">
                                    <span class="setting-name">Высота чердака:</span>
                                    <span class="setting-value">{{itemInCart.height_attic}} м</span>
                                </div>
                            </template>
                            <template v-if="itemInCart.height_full">
                                <div class="setting-item">
                                    <span class="setting-name">Общая высота:</span>
                                    <span class="setting-value">{{itemInCart.height_full}} м</span>
                                </div>
                            </template>
                        </div>
                        <div class="setting-item mb-0 mt-2" >
                            <div class="setting-option">
                                <router-link class="link-change" :to="{name: 'cartChange'}">Изменить комлектацию</router-link>
                            </div>
                            <div class="setting-value">
                                <a href="" @click.prevent="cleanCart" class="link-delete">Удалить из корзины</a>
                            </div>
                        </div>
                        <div class="gift-outer mb-0 mt-3" >
                            <router-link class="gift-link" :to="{name: 'gift'}"><span class="icon-span"><b-icon icon="gift"></b-icon></span> Выбрать подарок</router-link>
                        </div>
                    </div>
                </div>
                <br/>
                <hr>
                <div class="pay mt-5 mb-4">
                    <div class="to-pay">К оплате</div>
                    <div class="to-price">{{totalPrice}}</div>
                </div>

                <div class="mt-3 mb-5 button-wrapper" id="tinkoffForm">
                    <button type="button" @click="toOrderPage" class="btn btn-custom btn btn-block ">Оформить заказ</button>
                </div>
            </template>

        </template>
        <template v-else>
            <p class="item-title mb-3">В корзине пусто</p>
        </template>

    </div>
</template>
<script>
import ContentNavigation from "../components/General/ContentNavigation";
import Preloader from "../components/General/Preloader";
export default {
    data: function () {
        return {
            topNav: [
                {
                    title: "Главная",
                    routeName: "home",
                },
                {
                    title: "Корзина",
                    routeName: null,
                },
            ],
            loading: false,
        };
    },
    computed: {
        itemInCart(){
            return this.$store.getters["cart/project"]
        },
        filters() {
            return this.$store.getters["filters/list"];
        },
        totalPrice() {
            if (this.itemInCart && this.itemInCart.complectation && this.projectDocs) {
                return this.projectDocs.filter(doc => this.itemInCart.complectation.includes(String(doc.id))).map(doc => doc.price).reduce((a, b) => (a + b)) + "P";
            }
            return 0;
        },
        projectDocs(){
            return this.itemInCart ? this.$store.getters["cart/getDocByCode"](this.itemInCart.code) : null
        }
    },
    mounted() {
        if(this.itemInCart) {
            this.getDocsWithPrice()
        }
    },
    components: {
        ContentNavigation, Preloader
    },
    methods: {
        cleanCart(){
            this.$store.dispatch("cart/clearCart");
            this.$router.push({ name: "projects" });
        },
        getAvatar(avatar) {
            if (avatar && avatar.img_id) {
                const img = this.itemInCart.images.find(img => Number(img.id) === Number(avatar.img_id));
                return process.env.VUE_APP_URL + "/" + img.link;
            }
            return process.env.VUE_APP_URL + "/storage/default/avatar.jpg";
        },
        getFilterName(id) {
            return this.filters.length ? this.filters.find(filter => Number(filter.id) === Number(id)).title : null
        },
        getOptionName(option){
            return option.title
        },
        toOrderPage() {
            this.$router.push({ name: "order" });
        },
        getDocsWithPrice() {
            if(!this.projectDocs) {
                this.loading = true;
                this.$store.dispatch("cart/loadDocs", this.itemInCart.code).then(() => {
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
    },
    created() {
        this.loading = true
        this.$store.dispatch("filters/load").finally(() => {
            this.loading = false
        })
        this.$store.commit("navigation/SET_CURRENT_STATE", null)
    },
};
</script>
<style scoped>

    .image {
        width: 100%;
    }
    .img-outer{
        padding-left: 5%;
        padding-right: 2%;
    }
    .item-id{
        text-align: left;
    }
    .item-title{
        text-transform: uppercase;
    }
    .setting-item{
        display: flex;
        font-size: 14px;
        justify-content: space-between;
    }
    .setting-option{
        padding-right: 10px;
    }
    .setting-value{
        text-align: right;
    }
    .link-change{
        color: #FDC401;
    }
    .link-delete{
        color: #fd2401;
    }
    .pay{
        display: flex;
        justify-content: space-between;
        margin-left: 4%;
        text-transform: uppercase;
        font-size: 24px;
    }
    .btn-custom{
        color: #131111;
        background-color: #F6DB00;
        text-transform: uppercase;
        max-width: 500px;
        font-size: 24px;
    }
    .btn-custom:hover{
        background-color: #d5bf01;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
    }
    .gift-outer{
        text-align: center;
        font-size: 14px;
    }
    .gift-link{
        color: #3DBBC4;
    }
    .icon-span{
        font-size: 18px;
        padding-right: 4px;
    }
    .tech-settings {
        margin-bottom: 20px;
    }
    .setting-item {
        justify-content: space-between;
        display: flex;
    }
</style>
